const a = (e) => typeof e == "string" && (e === "blue" || e === "red" || e === "gray" || e === "orange" || e === "green"), t = (e) => a(e) ? e : "gray";
export {
  t as fallbackColor,
  a as validateColor
};
//# sourceMappingURL=highrise.es306.js.map
